module.exports = __webpack_public_path__ + "img/NH3N.ae710883.png";